import React from 'react'
import { EyeOff } from 'lucide-react'

const icon = props => <EyeOff size={20} {...props} />

export default icon
